import { css, Rule as CssRule } from 'glamor'
import * as PropTypes from 'prop-types'
import * as React from 'react'

import { isKey } from '../../utils'
import { useTheme } from '../../theme'

import getStyles from './styles'

interface IRuleProps {
  variant?: 'regular' | 'primary' | 'dim'
  tight?: boolean
  flush?: boolean
  strong?: boolean
  style?: CssRule
  width?: string
}

export const Rule: React.FC<IRuleProps> = ({ variant, tight, flush, width, strong, style }) => {
  const styles = getStyles(useTheme())
  return (
    <hr
      {...css([
        styles.base,
        isKey(styles.variants, variant) && styles.variants[variant],
        tight && styles.tight,
        flush && styles.flush,
        strong && styles.strong,
        { width },
        style,
      ])}
    />
  )
}

Rule.propTypes = {
  variant: PropTypes.oneOf(['regular', 'primary', 'dim']),
  tight: PropTypes.bool,
  flush: PropTypes.bool,
  strong: PropTypes.bool,
  style: PropTypes.object,
  width: PropTypes.string,
}

Rule.defaultProps = {
  flush: false,
  tight: false,
  strong: false,
  variant: 'regular',
}
